export default function redirectToLogin() {
  localStorage.setItem('login-redirect-path', window.location.pathname + window.location.hash);
  window.location = `/api/v1/oidc/auth?client_id=pricepoint&redirect_uri=${window
    .location.origin}/login/&scope=openid&response_type=code&nonce=nonce&claims=${JSON.stringify({
    userinfo:
     {
       id: null,
     },
  })}`;
}
